import { Component, type ErrorInfo, type ReactNode } from 'react';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

export default class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Falha inesperada ao renderizar a aplicação.', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="flex min-h-screen items-center justify-center bg-background px-4">
        <section className="w-full max-w-md rounded-lg border border-border-subtle bg-surface p-6 text-center shadow-sm">
          <i className="ri-error-warning-line text-3xl text-amber-600" aria-hidden />
          <h1 className="mt-3 font-fraunces text-xl font-semibold text-textPrimary">
            Não foi possível exibir esta tela
          </h1>
          <p className="mt-2 font-instrument text-sm text-textSecondary">
            Ocorreu uma falha inesperada. Recarregue a página para tentar novamente.
          </p>
          <button
            type="button"
            className="mt-5 inline-flex h-10 items-center justify-center gap-2 rounded-md bg-primary px-4 font-instrument text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
            onClick={() => window.location.reload()}
          >
            <i className="ri-refresh-line" aria-hidden />
            Recarregar página
          </button>
        </section>
      </main>
    );
  }
}
